/** Content styles for column picker modal — matches WarrChirp (hide scrollbar, allow overflow). */
export const getPopupContentStyle = (): Record<string, unknown> => ({
  overflowY: 'auto',
  '&::-webkit-scrollbar': { display: 'none' },
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
});
